export default __webpack_public_path__ + "static/transportation-accomplishment-1d-cdb81e197a4c85ec8c694ef823524de0.webp";